import React from 'react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
const pillars = ['Public company governance', 'Enterprise risk management', 'Regulatory transformation', 'Capital markets', 'Mergers & acquisitions', 'Compliance Management Systems'];
export function About() {
  return <section id="about" className="relative scroll-mt-24 bg-white py-24 lg:py-32" data-id="element-47" data-mp="271myaw8vgfpd">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-48" data-mp="1adgozw108z4r">
        <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-49" data-mp="1aaufvrygubkf">
          <SectionHeading eyebrow="Executive Profile" title="A legal executive built for the boardroom." data-id="element-50" data-mp="1eesd1x48dcau" />

          <div className="space-y-6 text-[1.0625rem] leading-[1.85] text-charcoal/80" data-id="element-51" data-mp="1jc10od85e8jh">
            <Reveal delay={0.05} data-id="element-52" data-mp="1o5n2facrws0i">
              <p data-id="element-53" data-mp="1o5wquti66r43">
                Jessica L. Cumbee is a Chief Legal Officer, General Counsel, and Corporate Secretary with 14+
                years of executive legal, governance, regulatory, and enterprise leadership experience across
                consumer finance, automotive lending, FinTech, capital markets, and publicly traded companies.
                She is a trusted strategic advisor to CEOs, executive leadership teams, and Boards of
                Directors on enterprise legal strategy, corporate governance, regulatory affairs, risk
                management, M&amp;A, financing transactions, and business transformation.
              </p>
            </Reveal>
            <Reveal delay={0.12} data-id="element-54" data-mp="1gfkp7nlqwm3n">
              <p data-id="element-55" data-mp="1biue7eossgp3">
                She has a proven record leading legal and compliance functions across complex, highly
                regulated environments — nationwide consumer finance operations, public-company governance,
                SEC reporting, capital markets, strategic transactions, and enterprise compliance
                transformation. She has built CFPB-aligned Compliance Management Systems from the ground up,
                managed licensing across all 50 states, Washington D.C., and Puerto Rico, and supported state
                and CFPB examinations.
              </p>
            </Reveal>
            <Reveal delay={0.18} data-id="element-56" data-mp="3ksahsgwvsr7u">
              <p data-id="element-57" data-mp="3ksjyfdw1dm0v">
                She is recognized for translating complex legal and regulatory requirements into commercially
                focused strategies that enable growth, protect enterprise value, and strengthen organizational
                resilience — from senior secured credit facilities and preferred equity financings to a $40M
                LIFE Offering and the relaunch of a national leasing platform.
              </p>
            </Reveal>

            <Reveal delay={0.24} data-id="element-58" data-mp="3ppadpz00odl8">
              <ul className="grid grid-cols-1 gap-x-8 gap-y-3 border-t border-navy/10 pt-8 sm:grid-cols-2" data-id="element-59" data-mp="3psg21c0tnbfw">
                {pillars.map(pillar => <li key={pillar} className="flex items-center gap-3 text-sm text-navy" data-id="element-60" data-mp="2eax2puqd3smm">
                    <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" data-id="element-61" data-mp="2jasyx7stifrm" />
                    {pillar}
                  </li>)}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}